export const environment = {
  production: false,
  apiBaseUrl: 'https://mockhub-api-test.azurewebsites.net',
  clientIdWeb: '581b7e4f-cfe7-432e-8868-e9d361d02a6e',
  clientIdApi: '96c12909-dd83-44d6-bff6-799148bd2d57',
  authority: 'https://login.microsoftonline.com/9b287ebb-a465-4ce0-8f89-4cc0afd6a80f',
  redirectUri: 'https://mockhub-test.lexima.nl',
};